export default {
	page: "Página",
	of: "de",
	itemsPerPage: "Itens por página",
	totalItems: "Mostrando {start} a {end} de {total} registros",
};
